<template>
    <div id="user_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="userHeader" v-if="$route.params.id > 0">Update User</span>
                    <span class="page-title" id="userHeader" v-else>Add User</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackUserList" >
                        <i class="fp-back"> </i>  Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content user-crud">
                      <div class="internal-container border-top-table-fl">
                            <div class="stepwizard">
                                <div class="stepwizard-row setup-panel">
                                    <div class="stepwizard-step">
                                        <a href="#step-1" type="button" class="btn btn-primary btn-circle" id="step1">1</a>
                                        <p>Basic Information</p>
                                    </div>
                                    <div class="stepwizard-step">
                                        <a href="#step-2" type="button" class="btn btn-tertiary btn-circle" disabled="disabled" id="step2">2</a>
                                        <p>Contact Information</p>
                                    </div>
                                    <div class="stepwizard-step">
                                        <a href="#step-3" type="button" class="btn btn-tertiary btn-circle" disabled="disabled">3</a>
                                        <p>Personal Information</p>
                                    </div>
                                    <div class="stepwizard-step" v-if="loadAllDealers">
                                        <a href="#step-4" type="button" class="btn btn-tertiary btn-circle" disabled="disabled">4</a>
                                        <p>Security Exception</p>
                                    </div>
                                </div>
                            </div>
                            <form method="posts" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="userform" autocomplete="off">
                                <div class="setup-content1 basic-info" id="step-1">
                                    <h3 class="color-darkblue"> Basic Information</h3>
                                    <div class="form-row row-cols-md-4 row-cols-1" >
                                        <div class="col form-group">
                                            <label class="control-label require">First Name</label>
                                            <input type="text" class="form-control" placeholder="Enter First Name" name="first_name" v-model="first_name" id="first_name"/>
                                            <div class="field-error">{{first_name_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Middle Name</label>
                                            <input type="text" class="form-control" name="middle_name" v-model="middle_name" id="middle_name" placeholder="Enter Middle Name"  />
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Last Name</label>
                                            <input type="text" class="form-control" name="last_name" v-model="last_name" id="last_name" placeholder="Enter Last Name" />
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require">User Name</label>
                                            <input type="text" class="form-control" v-model="username" id="username" placeholder="e.g. (xyz@abc.com)" :disabled = "username_disable" autocomplete="off"/>
                                            <div class="field-error">{{username_error_msg}}</div>
                                        </div>
                                        <div class="col form-group" v-if="!isEdit">
                                            <label class="control-label require">Password</label>
                                            <input type="password" class="form-control" name="password" v-model="password" id="password" placeholder="Enter Password" ref="password" autocomplete="off"/>
                                            <div class="field-error">{{password_error_msg}}</div>
                                        </div>
                                        <div class="col form-group" v-if="!isEdit">
                                            <label class="control-label require">Confirm Password</label>
                                            <input type="password" class="form-control" name="confirmpassword" v-model="confirmpassword" id="confirmpassword" placeholder="Enter Confirm Password"/>
                                            <div class="field-error">{{confirmpassword_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="module">Role</label>
                                             <v-select
                                                class="multiselect"
                                                v-model="selectRole"
                                                @change="handleRoleSelection"
                                                :options="roleArr"
                                                :close-on-select="true"
                                                :show-labels="true"
                                                :multiple="true"
                                                :searchable="true"
                                                track-by="value"
                                                label="name"
                                                placeholder="Select Role.">
                                            </v-select>
                                            <div class="field-error">{{role_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="selectTimeZone">TimeZone</label>

                                            <v-select class="close-remove"  v-model="selectTimeZone" name="selectTimeZone"
                                            placeholder="Select TimeZone."
                                                    label="text"
                                                    :options="timezoneArr" id="timezone">
                                            </v-select>
                                            <div class="field-error">{{timezone_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="selectDateFormat">Date Format</label>
                                            <v-select class="close-remove" disabled v-model="selectDateFormat" name="selectDateFormat" placeholder="Select Date Format."
                                                    label="text"
                                                    :options="dateFormatArr" id="dateformat">
                                            </v-select>
                                            <div class="field-error">{{dateformat_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="selectTimeFormat">Time Format</label>
                                            <v-select class="close-remove" disabled v-model="selectTimeFormat" name="selectTimeFormat" placeholder="Select Time Format."
                                                    label="text"
                                                    :options="timeFormatArr" id="timeformat">
                                            </v-select>
                                            <div class="field-error">{{timeformat_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Email</label>
                                            <input type="text" class="form-control" name="email" v-model="email" id="email"/>
                                            <div class="field-error">{{email_error_msg}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Phone Number</label>
                                            <div class="input-group" id="div_work_phone">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="work_phone_label">Work Phone</span>
                                                </div>
                                                <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="work_phone" id="work_phone" placeholder="999-999-9999" name="work_phone">
                                            </div>
                                            <div class="field-error">{{work_phone_error_msg}}</div>
                                        </div>

                                        <div class="col form-group" v-if="showDealers && loadAllDealers">
                                            <label class="control-label require" for="billCusId">Bill Cus Id</label>
                                            <v-select
                                              v-model="billCusId"
                                              class="multiselect"
                                              name="billCusId"
                                              placeholder="Select Bill Cus Id"
                                              label="text"
                                              @search="onSearchBillCusId"
                                              @input="populateDealers()"
                                              :multiple="true"
                                              :options="billCusIdArr"
                                              id="billCusId"
                                              :searchable="true"
                                              :close-on-select="true"
                                              track-by="value"
                                              :show-labels="true"
                                              open-direction="bottom"
                                            >
                                            </v-select>
                                            <div class="field-error">{{billCusIdErrorMSg}}</div>
                                        </div>

                                        <div class="col form-group" v-if="showDealers">
                                            <label class="control-label require" for="dealer">Dealer</label>
                                            <v-select v-model="dealer" name="dealer" placeholder="Select Dealer"
                                                    label="text"
                                                    :options="dealerArr" id="dealer"
                                                    @input="selectDealer()">
                                            </v-select>
                                            <div class="field-error">{{dealerErrorMsg}}</div>
                                        </div>
                                        <div v-if="dealerArr.length > 0 && showDealers" class="col form-group">
                                            <label class="control-label require" for="dealer">Selected Dealers</label>
                                            <table class="table table-bordered font-1">
                                              <caption>This table displays the selected Dealers.</caption>
                                              <thead>
                                                <tr class="table-primary">
                                                  <th>Dealer</th>
                                                  <th>Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <template v-for="(value,key) in selectedDealerArr">
                                                  <tr>
                                                    <td>{{ value.text }}</td>
                                                    <td>
                                                      <a href="javascript:void(0);" v-on:click="removeDealer(key);"> <i class="fp-remove"></i> </a>
                                                    </td>
                                                  </tr>
                                                </template>
                                              </tbody>
                                            </table>
                                            <div class="field-error">{{selectedDealerErrorMsg}}</div>
                                        </div>
                                    </div>
                                    <div class="form-row row-cols-md-2 row-cols-1 custom-dropzone-container">
                                        <div class="col form-group">
                                            <label class="control-label">Photo</label>
                                            <div id="app1">
                                                <vue-dropzone
                                                    id="drop1"
                                                    :options="dropzoneOptions"
                                                    ref="dropzone"
                                                    :headers="dropzoneOptions.headers"
                                                    @vdropzone-complete="afterComplete"
                                                    @vdropzone-success="storeImage"
                                                    @vdropzone-removed-file="removedTempFile"
                                                    >
                                                </vue-dropzone>
                                                <img v-if="isUpdate && imageURL!=''" :src="imageURL" class="custom-preview-thumbnail-img" alt="">
                                            </div>
                                            <small class="des-address-ex info">Image will be re-sized to 90x90. JPG, PNG</small>
                                        </div>
                                    </div>
                                    <div class="technican">
                                    <hr class="light-hr " style="border-style:dashed"/>
                                    <h5 class="color-darkblue">Technician Details</h5>
                                    <div class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label">Hourly Labour Rate</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon4">$</span>
                                                </div>
                                                <input  type="number" id="hourly_labor_rate" name="hourly_labor_rate" class="form-control" placeholder="" v-model="hourly_labor_rate" aria-describedby="basic-addon4" @keypress="isAmountCheck($event)">
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Shift Hours</label>
                                            <input type="number" id="shift_hours" name="shift_hours" class="form-control" placeholder="" v-model="shift_hours" aria-describedby="basic-addon4" @keypress="isAmountCheck($event)">
                                            <div class="field-error">{{shift_hours_error_msg}}</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="alert alert-warning hide col-sm-6">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong class="errormsg"></strong>
                                    </div>
                                    <div class="btn-groups mt-3">
                                        <button id="createUserBtnStep1" class="btn btn-primary" v-if="$route.params.id > 0" type="button" v-on:click.prevent="CreateUser()" >
                                        <i class="fp-reload"> </i>Update</button>
                                        <button id="createUserBtnStep1" class="btn btn-primary" v-else type="button" v-on:click.prevent="CreateUser()" >
                                        <i class="fp-save"> </i>  Save
                                        </button>
                                        <button id="createAndContinueUserBtnStep1" class="btn btn-tertiary" v-if="$route.params.id == undefined" type="button" v-on:click.prevent="CreateUser(flag='Save and Continue')">
                                            <i class="fp-save-continue"></i> Save and Continue
                                        </button>
                                        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNextStep('step-1')" >Next <i class="fp-right-arrow right-icon"> </i></button>
                                    </div>
                                </div>
                                <div class="setup-content contact-info" id="step-2">
                                    <h3 class="color-darkblue"> Contact Information</h3>
                                    <div class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group">
                                            <div class="example-label">
                                                <label class="control-label">Street Address</label>
                                            </div>
                                            <input type="text" id="address_1" name="address_1" class="form-control" v-model="address_1">
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <div class="example-label">
                                                <label class="control-label">Address 2</label>
                                            </div>
                                            <input type="text" id="address_2" name="address_2" class="form-control" v-model="address_2">
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">State/Province/Region</label>
                                            <v-select v-model="state" name="state"
                                                    label="text" :filterable="false" :options="stateArr"
                                                    @search="onSearchState"
                                                    @change="stateChanged($event)"
                                                    placeholder="Select State" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search State...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">City</label>
                                            <v-select v-model="city" name="city"
                                                    label="text" :filterable="false" :options="cityArr"
                                                    @search="onSearchCity"
                                                    @change="cityChanged($event)"
                                                    placeholder="Select City" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search City...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">{{ zip_postal }}</label>
                                            <input type="text" id="zip" name="zip" class="form-control" v-model="zip">
                                            <div class="field-error">{{ zip_error_msg }}</div>
                                        </div>
                                    </div>
                                    <div class="form-row row-cols-md-2 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label">Phone Number</label>
                                            <div class="form-row">
                                                <div class="col-auto add-multi-phoneno">
                                                    <div class="input-group form-group" id="div_mobile_phone">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="mobile_phone_label">Mobile Phone</span>
                                                        </div>
                                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="mobile_phone" id="mobile_phone" placeholder="999-999-9999" name="mobile_phone">
                                                        <div class="field-error add-user-error-msg">{{mobile_phone_error_msg}}</div>
                                                    </div>
                                                    <div class="input-group hide form-group" id="div_home_phone">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="home_phone_label">Home Phone</span>
                                                        </div>
                                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="home_phone" id="home_phone" placeholder="999-999-9999" name="home_phone">
                                                        <span class="fp-remove remove-phone" v-on:click.prevent="clearPhoneNumber('home_phone')"></span>
                                                        <div class="field-error add-user-error-msg">{{home_phone_error_msg}}</div>
                                                    </div>
                                                    <div class="input-group hide form-group" id="div_other_phone">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="other_phone_label">Other Phone</span>
                                                        </div>
                                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="other_phone" id="other_phone" placeholder="999-999-9999" name="other_phone">
                                                        <span class="fp-remove remove-phone" v-on:click.prevent="clearPhoneNumber('other_phone')"></span>
                                                        <div class="field-error add-user-error-msg">{{other_phone_error_msg}}</div>
                                                    </div>
                                                </div>
                                                <div class="col-auto">
                                                    <button class="btn btn-primary" id="add_phone" type="button" v-on:click.prevent="addPhoneNumber()"> <i class="fp-add-phone"></i> Add Phone</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="alert alert-warning hide w-50">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong class="errormsg"></strong>
                                    </div>
                                    <div class="btn-groups mt-3">
                                        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoBackStep('step-1')">   <i class="fp-left-arrow" style="font-size:20px;"> </i> Previous </button>
                                        <button id="createUserBtnStep2" class="btn btn-primary" type="button" v-if="$route.params.id > 0" v-on:click.prevent="CreateUser()"> <i class="fp-reload"> </i> Update</button>
                                        <button id="createUserBtnStep2" class="btn btn-primary" type="button" v-else v-on:click.prevent="CreateUser()"> <i class="fp-save"> </i> Save</button>
                                        <button id="createAndContinueUserBtnStep2" class="btn btn-tertiary btn-text-indent" type="button" v-if="$route.params.id == undefined" v-on:click.prevent="CreateUser(flag='Save and Continue')"> <i class="fp-save-continue"> </i> Save and Continue</button>
                                        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNextStep('step-2')">  Next <i class="fp-right-arrow right-icon"> </i></button>
                                    </div>
                                </div>
                                <div class="setup-content user-personal-info" id="step-3">
                                    <h3 class="color-darkblue"> Personal Information</h3>
                                    <h5 class="color-darkblue">Employee Details</h5>
                                    <div class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label">Job Title</label>
                                            <input type="text" id="job_title" name="job_title" class="form-control" placeholder="Ex. Assistant to the Regional Manager" v-model="job_title">
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Date of Birth</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="date_of_birth" name="date_of_birth" v-model="date_of_birth" :config="options" aria-describedby="basic-addon1"></date-picker>
                                                <label for="date_of_birth" class="fp-calender input-calender-icon" id="basic-addon1"></label>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Start Date</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="joining_date" name="joining_date" v-model="joining_date" :config="optionsDate" aria-describedby="basic-addon2"></date-picker>
                                                <label for="joining_date" class="fp-calender input-calender-icon" id="basic-addon2"></label>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Leave Date</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="leaving_date" name="leaving_date" v-model="leaving_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="leaving_date" class="fp-calender input-calender-icon" id="basic-addon3"></label>
                                            </div>
                                            <div class="field-error">{{leaving_date_error_msg}}</div>
                                        </div>
                                    </div>
                                    <hr class="light-hr " style="border-style:dashed"/>
                                    <h5 class="color-darkblue">Operator Details</h5>
                                    <div class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label">License Number</label>
                                            <input type="text" id="license_no" name="license_no" class="form-control" placeholder="" v-model="license_no">
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">License State / Province / Region</label>
                                            <input type="text" id="license_state" name="license_state" class="form-control" placeholder="" v-model="license_state">
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">License Class</label>
                                            <input type="text" id="license_class" name="license_class" class="form-control" placeholder="" v-model="license_class">
                                        </div>
                                    </div>
                                    <div class="alert alert-warning hide col-sm-6">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong class="errormsg"></strong>
                                    </div>
                                    <div class="btn-groups mt-3">
                                        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoBackStep('step-2')">   <i class="fp-left-arrow" style="font-size:20px;"> </i> Previous </button>
                                        <button id="createUserBtnStep3" class="btn btn-primary" type="button" v-if="$route.params.id > 0" v-on:click.prevent="CreateUser()" >
                                            <i class="fp-reload"> </i> Update
                                        </button>
                                        <button id="createUserBtnStep3" class="btn btn-primary" type="button" v-else v-on:click.prevent="CreateUser()" >
                                            <i class="fp-save"> </i> Save
                                        </button>
                                        <button id="createAndContinueUserBtnStep3" class="btn btn-tertiary btn-text-indent" type="button" v-if="$route.params.id == undefined" v-on:click.prevent="CreateUser(flag='Save and Continue')">
                                            <i class="fp-save-continue"> </i> Save and Continue
                                        </button>
                                        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNextStep('step-3')" >Next <i class="fp-right-arrow right-icon"> </i></button>
                                    </div>
                                </div>
                                <div class="setup-content user-personal-info" id="step-4">
                                    <div class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group">
                                            <label class="control-label" for="module">Module : </label>
                                            <v-select placeholder="Select Module" v-model="moduleId" label="text" :options="moduleArr" @input="onModuleChange($event)"></v-select>
                                            <div class="field-error">{{ module_error_msg }}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="permission">Permission : </label>
                                            <v-select
                                                class="multiselect"
                                                v-model="permissionArr"
                                                :options="modulePermissionArr"
                                                :close-on-select="true"
                                                :show-labels="true"
                                                :multiple="true"
                                                :searchable="true"
                                                track-by="value"
                                                label="text"
                                                placeholder="Select Permission.">
                                            </v-select>
                                            <div class="field-error">{{ permission_error_msg }}</div>
                                        </div>
                                        <div class="col form-group mt-4">
                                            <button id="addPermissionBtn" class="btn btn-primary" type="button" v-on:click.prevent="addPermissions()" >
                                                <i class="fp-add"> </i> Add
                                            </button>
                                            <button id="addPermissionBtn" class="btn btn-tertiary" type="button" v-on:click.prevent="resetFields()" >
                                                <i class="fp-refresh"> </i> Reset
                                            </button>
                                        </div>
                                    </div>
                                    <template v-if="selectedPermissionsArr.length > 0">
                                        <div class="form-row row-cols-md-4 row-cols-1">
                                        <template v-for="(mp, index) in selectedPermissionsArr">
                                            <div :key="index" class="col form-group">
                                                <h6 class="color-darkblue">{{mp.module_name}}</h6>
                                                <template v-if="mp.permissions.length > 0">
                                                    <template v-for="(pData,pKey) in mp.permissions">
                                                        <div class="form-row" :key="pKey">
                                                            <label class="col">{{pData.text}}</label>
                                                            <div class="col">
                                                                <a href="javascript:void(0)" v-on:click.prevent="removePermission($event,index,pKey,pData.id)"> <i class="fp-remove color-red"></i> </a>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </div>
                                            <p :key="index+'p'">&nbsp;&nbsp;</p>
                                        </template>
                                        </div>
                                    </template>
                                    <div class="alert alert-warning hide col-sm-6">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong class="errormsg"></strong>
                                    </div>
                                    <div class="btn-groups mt-3">
                                        <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoBackStep('step-3')">   <i class="fp-left-arrow" style="font-size:20px;"> </i> Previous </button>
                                        <button id="createUserBtnStep4" class="btn btn-primary" type="button" v-if="$route.params.id > 0" v-on:click.prevent="gotoNextStep('step-4')" >
                                            <i class="fp-reload"> </i> Update
                                        </button>
                                        <button id="createUserBtnStep4" class="btn btn-primary" type="button" v-else v-on:click.prevent="gotoNextStep('step-4')" >
                                            <i class="fp-save"> </i> Save
                                        </button>
                                        <button id="createAndContinueUserBtnStep4" class="btn btn-tertiary" type="button" v-if="$route.params.id == undefined" v-on:click.prevent="CreateUser(flag='Save and Continue')">
                                            <i class="fp-save-continue"> </i> Save and Continue
                                        </button>
                                    </div>
                                </div>
                            </form>
                      </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

//Vue DropZone
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);

var state = {
    date: new Date(2016, 9,  16)
}

export default {
    name: "UserCreate",
    components: {
        vueDropzone: vue2Dropzone,

    },
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update User | " +process.env.COPYRIGHT_NAME : "Create User | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
        selectDateFormat: {value: "m/d/Y", text: '12/23/2019'},
        selectTimeFormat: {value: "h:i:s a", text: '09:58:00 am'},
        dateformat_error_msg: "",
        timeformat_error_msg: "",
        location_error_msg: "",
        locationId:"",
        defaultLocationId: "",
        insLocationArr: [],
        locationArr:[],
        finalLocationArr:[],
        permissions: [],
        cantAccessPage: "",
        isEdit:false,
        isUpdate:false,
        cityArr:[],
        stateArr:[],
        countryArr:[],
        options: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
            maxDate:new Date,
            toolbarPlacement:'bottom',
            widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
            },
        },
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        date_of_birth: "",
        joining_date: "",
        leaving_date: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email: "",
        username: "",
        password: "",
        confirmpassword: "",
        valueImage: false,
        imageURL: "",
        uploadedImage: "",
        selectTimeZone: null,
        timezoneArr: [],
        selectRole: [],
        roleArr: [],
        rowsFiles: [],
        work_phone: "",
        mobile_phone: "",
        home_phone: "",
        other_phone: "",
        count: 0,
        address_1: "",
        address_2: "",
        city: null,
        state: null,
        zip: "",
        country: "",
        job_title: "",
        employee_no: "",
        license_no: "",
        license_class: "",
        license_state: "",
        hourly_labor_rate: "",
        dropzoneOptions: {
            url: process.env.ROOT_API +"/store-user-image",
            method: 'POST',
            maxFilesize: 3.99, //MB
            maxFiles: 1,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            addRemoveLinks: true,
            acceptedFiles: ".jpg, .jpeg, .png",
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            dictRemoveFileConfirmation: "Are you sure? You can\'t revert your action",
            destroyDropzone:false,
        },
        loading:false,
        first_name_error_msg: "",
        username_error_msg: "",
        password_error_msg: "",
        confirmpassword_error_msg: "",
        timezone_error_msg: "",
        role_error_msg: "",
        email_error_msg: "",
        work_phone_error_msg: "",
        home_phone_error_msg: "",
        mobile_phone_error_msg: "",
        other_phone_error_msg:"",
        leaving_date_error_msg:"",
        moduleArr:[],
        moduleId:"",
        module_error_msg:"",
        permissionArr:[],
        modulePermissionArr:[],
        permission_error_msg:"",
        selectedPermissionsArr:[],
        removePermissionArr:[],
        shift_hours:"",
        shift_hours_error_msg:"",
        username_disable:false,
        billCusId: [],
        billCusIdArr: [],
        billCusIdErrorMSg: "",
        dealer: "",
        dealerArr: [],
        selectedDealerArr: [],
        dealerErrorMsg: "",
        selectedDealerErrorMsg: "Dealer Must Be Selected",
        showDealers: false,
        tempBillCussIdArr: [],
        loadAllDealers: false,
        zip_error_msg: ''
  }),
  watch: {

      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_user') {
                        self.cantAccessPage = true;

                        setTimeout(function () {

                            var navListItems = $('div.setup-panel div a'),
                                allWells = $('.setup-content'),
                                allNextBtn = $('.nextBtn');

                            allWells.hide();

                            navListItems.click(function (e) {
                                e.preventDefault();
                                var $target = $($(this).attr('href')),
                                    $item = $(this);


                                if (!$item.hasClass('disabled')) {
                                    navListItems.removeClass('btn-primary').addClass('btn-tertiary');
                                    $item.removeClass('btn-tertiary').addClass('btn-primary');
                                    allWells.hide();
                                    $('.setup-content1').hide();
                                    $target.show();
                                    $target.find('input:eq(0)').focus();
                                }
                            });
                        }, 1000);
                  }
                  if (permissions[i].name == 'ev_load_all_dealer_dropdown') {
                    self.loadAllDealers = true;
                  }
              }
            if (!self.loadAllDealers) {
              let userObj = JSON.parse(localStorage.getItem("user_obj"));
              self.loadUserDealerMapper(userObj.id);
            }
          }

      },
      selectRole: function(selectRole){
        let includesDealer = false;
        for (const element of this.selectRole) {
            let name = element.name.toLowerCase();
            includesDealer = name.includes("dealer");
            if(includesDealer){
                break;
            }
        }
        this.showDealers = includesDealer;
      },

        //if state value update after then change the city value also update that in thie module.
        state: function(state) {

            var self = this;

            if(self.state == null){
                self.city = null;
                self.cityArr = [];
            }
        },
  },
  created: function() {

  },
  mounted: function() {
        var self = this;

    //   setTimeout(function () {
    //       var navListItems = $('div.setup-panel div a'),
    //           allWells = $('.setup-content'),
    //           allNextBtn = $('.nextBtn');

    //       allWells.hide();

    //       navListItems.click(function (e) {
    //           e.preventDefault();
    //           var $target = $($(this).attr('href')),
    //               $item = $(this);


    //           if (!$item.hasClass('disabled')) {
    //               navListItems.removeClass('btn-primary').addClass('btn-default');
    //               $item.addClass('btn-primary');
    //               allWells.hide();
    //               $('.setup-content1').hide();
    //               $target.show();
    //               $target.find('input:eq(0)').focus();
    //           }
    //       });
    //   }, 1000);
        $('div.setup-panel div a.btn-primary').trigger('click');

        // $("#clear").click(function(){
        //     $(".resultingarticles").empty();
        //     $("#searchbox").val("");
        // });

        self.getPermissions();
        self.getModulePermissions();
        self.loadFieldData(['location','role','timezone']);
        self.getUserDefaultLocation();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            // $("#createUserBtnStep1").text("Update");
            // $("#createUserBtnStep2").text("Update");
            // $("#createUserBtnStep3").text("Update");
            // $("#createAndContinueUserBtnStep1").hide();
            // $("#createAndContinueUserBtnStep2").hide();
            // $("#createAndContinueUserBtnStep3").hide();
            // $("#userHeader").text("Edit User");

            //remove disabled attribute while update user
            setTimeout(function () {
                self.loadUser();
            }, 500);
        }
        setTimeout(function () {
            self.loadFieldData(['ins_locations']);
            self.finalLocationArr = self.locationArr;
        }, 999);
  },
  methods: {
        stateChanged(value) {
            if(
                value == null
                ||
                value == ''
            )
            {
                this.city = '';
                this.state = '';
                this.cityArr = [];
                this.stateArr = [];
            }
        },
        cityChanged(value) {
            if(
                value == null
                ||
                value == ''
            )
            {
                this.city = '';
                this.cityArr = [];
            }
        },
       getTimeZone(locId){

            var self = this;
            if ( locId && locId.value != undefined ) {
               self.selectTimeZone = {value: locId.timezone_id, text: self.titleCase(locId.timezone_name)};
            }
        },

      onSearchState(search, loading) {
          if (search.length > 2) {

              loading(true);
              this.searchField(loading, search, 'state');
          }
      },
      onSearchBillCusId(search, loading) {
          if (search.length > 2) {

              loading(true);
              this.searchField(loading, search, 'billCusId');
          }
      },
      onSearchCity(search, loading) {

          if (search.length > 2) {
            var stateId = '';
            if(
                this.state != null
                &&
                this.state != ''
                &&
                this.state.value != undefined
            )
            {
                stateId = this.state.value;
            } else {
                alert("please select state first");
                return;
            }

            loading(true);
            this.searchField(loading, search, 'city');
          }
      },



    BackUserList() {
        var self = this;
        self.$router.push("/user/list");
    },

    removedTempFile(file, xhr, error) {
        console.log(file.fileid);

        var self = this;
        self.removeSelectedFile(file.fileid,'temp');

        self.removedFile = true;
        self.valueImage = false;
        // self.imageURL = "";

        var self = this;

    },

    removeSelectedFile(file, flag) {

        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/user/remove-user-image",
            type: "POST",
            data: {
                filePath : file,
                flag:flag
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
                return true;
            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'user-image-remove')
            }
        });
    },

    removeAllFiles() {
        var self = this;
        self.$refs.dropzone.removeAllFiles();
    },

    storeImage(file,response){
        var self = this;
        file.fileid = response.content;
        self.uploadedImage = response.content;
        console.log(self.uploadedImage);
        console.log(file);
    },

    afterComplete(file){
        var self = this;
        if (self.valueImage == false) {
            var self = this;
            // self.imageURL = file.dataURL;
            self.valueImage = true;

        } else {
            self.$refs.dropzone.removeFile(file);
        }

    },

    gotoBackStep: function(flag){
        console.log("flag" + flag);
        var self = this;
    // alert('in');

        if (flag == 'step-1') {
         $('div.setup-panel div a[href="#step-1"]').trigger('click');
        }
        if (flag == 'step-2') {
         $('div.setup-panel div a[href="#step-2"]').trigger('click');
        }
        if (flag == 'step-3') {
         $('div.setup-panel div a[href="#step-3"]').trigger('click');
        }
    },
    is_numeric(s){
      return !isNaN(s - parseFloat(s));
    },
    gotoNextStep: function(flag) {
        console.log("flag" + flag);
        var self = this;

          var error = false;
          var path = window.location.pathname;
          var segments = path.split("/");
          self.first_name_error_msg = "";
          self.username_error_msg = "";
          self.password_error_msg = "";
          self.confirmpassword_error_msg = "";
          self.timezone_error_msg = "";
          self.role_error_msg = "";
          self.email_error_msg = "";
          self.work_phone_error_msg = "";
          self.mobile_phone_error_msg = "";
          self.home_phone_error_msg = "";
          self.other_phone_error_msg = "";
          self.leaving_date_error_msg = "";
          self.timeformat_error_msg = "";
          self.dateformat_error_msg = "";
          self.shift_hours_error_msg = "";
          self.dealerErrorMsg = "";
          self.billCusIdErrorMSg = "";
        //     if (result) {

                if (flag == 'step-1') {

                    if(self.selectTimeFormat == null || !self.selectTimeFormat.value) {
                        self.timeformat_error_msg = "Time Format Required.";
                        error = true;
                    }
                    if(self.selectDateFormat == null || !self.selectDateFormat.value) {
                        self.dateformat_error_msg = "Date Format Required.";
                        error = true;
                    }
                    if (!self.first_name || self.first_name == null || self.first_name == "") {
                        self.first_name_error_msg = "First Name Required.";
                        error = true;
                    }

                    if (!self.username || self.username == null || self.username == "") {
                        self.username_error_msg = "User Name Required.";
                        error = true;
                    }


                    // console.log("test 2 ===",self.is_numeric(self.username));
                    // if (self.username == "" ||  self.username == null) { //&& !self.is_numeric(self.username) && !self.validEmail(self.username)
                    //     self.username_error_msg = "Username Must Be In Proper Email Format.";
                    //     error = true;
                    // }
                    if (self.selectRole != null && self.selectRole[0]) {
                        for(var i = 0; i < self.selectRole.length; i++){
                            if (self.selectRole[i].name.toLowerCase() == "technician") {
                                if (self.shift_hours == "" || self.shift_hours == 0) {
                                    self.shift_hours_error_msg = "Shift Hours Required.";
                                    error = true;
                                }
                            }
                        }
                    }

                    if(segments[3]){
                        self.password_error_msg = "";
                        self.confirmpassword_error_msg = "";
                    }else{

                        if (!self.password || self.password == null || self.password == "") {
                            self.password_error_msg = self.passReq;
                            error = true;
                        }

                        if (!self.confirmpassword || self.confirmpassword == null || self.confirmpassword == "") {
                            self.confirmpassword_error_msg = self.confPassReqErr;
                            error = true;
                        }

                        if (self.password != self.confirmpassword && self.confirmpassword !="") {
                            self.confirmpassword_error_msg = "";
                            self.confirmpassword_error_msg = self.confPassMatchErr;
                            error = true;
                        }
                    }

                    if (self.email && !self.validEmail(self.email)) {
                        self.email_error_msg = "Enter Valid Email.";
                        error = true;
                    }

                    if (self.selectTimeZone == null || !self.selectTimeZone.value) {
                        self.timezone_error_msg = "Time Zone Required.";
                        error = true;
                    }

                    if (self.selectRole == null || !self.selectRole[0]) {
                        self.role_error_msg = "Role Required.";
                        error = true;
                    }

                    var workPhoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

                    if(!self.work_phone || self.work_phone == null || self.work_phone == "" || self.work_phone=='___-___-____'){
                        // self.work_phone_error_msg = "Work Phone Required.";
                        // error = true;
                    }

                    if(self.work_phone && self.work_phone != '___-___-____' && !self.work_phone.match(workPhoneRE)){
                        self.work_phone_error_msg = "Work phone number must be in proper format.";
                        error = true;
                    }

                    if(self.showDealers && self.selectedDealerArr.length == 0){
                        self.dealerErrorMsg = "Dealer must be selected";
                        error = true;
                    }

                    if(self.showDealers && self.billCusId.length == 0){
                        self.billCusIdErrorMSg = "Bill Cus Id must be selected";
                        error = true;
                    }

                    // self.display1 = false;
                    // self.display2 = true;
                    if(error != true){
                        $('.setup-content1').hide();
                        var curStep = $(this).closest(".setup-content"),
                            curStepBtn = curStep.attr("id"),
                            nextStepWizard = $('div.setup-panel div a[href="#' + flag + '"]').parent().next().children("a");

                        nextStepWizard.removeAttr('disabled').trigger('click');
                    } else {
                        self.errorValidationFocus();
                    }


                } else if (flag == 'step-2') {
                    // self.display2 = false;
                    // self.display3 = true;
                    // Pr - Disable Field
                    /*if(!self.work_phone){
                        self.work_phone_error_msg = "Work Phone Required";
                        error = true;
                    }*/
                    /*if(self.work_phone && !String(self.work_phone).match(/^[0-9]*$/)){
                        self.work_phone_error_msg = "Work Phone Must Be Numeric";
                        error = true;
                    }

                    if(self.work_phone && String(self.work_phone).match(/^[0-9]*$/) && self.work_phone.length < 10){
                        self.work_phone_error_msg = "Work Phone Must Be Of Minimum 10 Digits";
                        error = true;
                    }

                    if(self.work_phone && String(self.work_phone).match(/^[0-9]*$/) && self.work_phone.length > 12){
                        self.work_phone_error_msg = "Work Phone Must Be Of Maximum 12 Digits";
                        error = true;
                    }*/
                    var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

                    // if(self.work_phone && !self.work_phone.match(phoneRE)){
                    //     self.work_phone_number_error_msg = "Work phone number must be in proper format";
                    //     error = true;
                    // }
                    if(self.home_phone && !self.home_phone.match(phoneRE)  && self.home_phone!='___-___-____'){
                        self.home_phone_error_msg = "Home phone number must be in proper format";
                        error = true;
                    }

                    if(self.mobile_phone && !self.mobile_phone.match(phoneRE) && self.mobile_phone!='___-___-____'){
                        self.mobile_phone_error_msg = "Mobile phone number must be in proper format";
                        error = true;
                    }

                    if(self.other_phone && !self.other_phone.match(phoneRE) && self.other_phone!='___-___-____'){
                        self.other_phone_error_msg = "Other phone number must be in proper format";
                        error = true;
                    }

                    if(error != true){
                        var curStep = $(this).closest(".setup-content"),
                            curStepBtn = curStep.attr("id"),
                            nextStepWizard = $('div.setup-panel div a[href="#' + flag + '"]').parent().next().children("a");

                        nextStepWizard.removeAttr('disabled').trigger('click');
                    } else {
                        self.errorValidationFocus();
                    }

                } else if (flag == 'step-3') {

                    if( Date.parse(self.joining_date) > Date.parse(self.leaving_date) ){
                        self.leaving_date_error_msg = "Leave Date should not be earlier than Start Date";
                        error = true;
                    }
                    //role is technician
                    // if (self.selectRole != null && self.selectRole[0]) {
                    //     for(var i = 0; i < self.selectRole.length; i++){
                    //         if (self.selectRole[i].name.toLowerCase() == "technician") {
                    //             if (self.shift_hours == "" || self.shift_hours == 0) {
                    //                 self.shift_hours_error_msg = "Shift Hours Required.";
                    //                 error = true;
                    //             }
                    //         }
                    //     }
                    // }

                    if(error != true){
                        // self.CreateUser(flag);
                        var curStep = $(this).closest(".setup-content"),
                            curStepBtn = curStep.attr("id"),
                            nextStepWizard = $('div.setup-panel div a[href="#' + flag + '"]').parent().next().children("a");

                        nextStepWizard.removeAttr('disabled').trigger('click');
                    } else {
                        self.errorValidationFocus();
                    }

                }else {//step 4

                    if(error != true){
                        self.CreateUser(flag);
                    }

                }
                $('div.setup-panel div a.btn-primary').trigger('click');
            // }
        // });
    },

    addPhoneNumber() {

        var self = this;

        // if ( $("#div_mobile_phone").hasClass("hide") ) {
        //     $("#div_mobile_phone").removeClass("hide");
        //     return;
        // }

        if ( $("#div_home_phone").hasClass("hide") ) {
            $("#div_home_phone").removeClass("hide");
            return;
        }

        if ( $("#div_other_phone").hasClass("hide") ) {
            $("#div_other_phone").removeClass("hide");
            return;
        }

        // if ( !($("#div_mobile_phone").hasClass("hide")) ) {
        //     $("#add_phone").hide();
        // }

        // if ( !($("#div_home_phone").hasClass("hide")) ) {
        //     $("#add_phone").hide();
        // }

        // if ( !($("#div_other_phone").hasClass("hide")) ) {
        //     $("#add_phone").hide();
        // }
    },

    clearPhoneNumber(flagPhoneNumber){

        var self = this;

        // if (flagPhoneNumber == 'mobile_phone') {

        //     self.mobile_phone_error_msg = "";
        //     self.mobile_phone = "";
        //     $("#div_mobile_phone").addClass("hide");
        //     $("#add_phone").show();

        // }
        if (flagPhoneNumber == 'home_phone') {
            self.home_phone_error_msg = "";
            self.home_phone = "";
            $("#div_home_phone").addClass("hide");
            $("#add_phone").show();

        } else {
            self.other_phone_error_msg = "";
            self.other_phone = "";
            $("#div_other_phone").addClass("hide");
            $("#add_phone").show();
        }
    },
    handleRoleSelection() {
        var self = this;
        self.locationId = self.defaultLocationId;
        var is_ins_agent = false;
        var is_technician = false;
        $('.technican').hide();
        for(var i = 0; i < self.selectRole.length; i++){
            if (self.selectRole[i].name.toLowerCase() == "technician") {
                is_technician = true;
            }
        }
        if(is_technician == true){
            $('.technican').show();
        }
        if (self.selectRole.length > 0) {
            for(var i = 0; i < self.selectRole.length; i++){
                if (self.selectRole[i].name == 'Insurance Agent') {
                    is_ins_agent = true;
                }
            }
        }
        if(is_ins_agent) {
            self.finalLocationArr = self.insLocationArr;
        } else {
            self.finalLocationArr = self.locationArr;
        }
    },
    CreateUser(flag) {

        var self = this;
        var error = false;
        var error_step_1 = false;
        var error_step_2 = false;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.first_name_error_msg = "";
        self.username_error_msg = "";
        self.password_error_msg = "";
        self.confirmpassword_error_msg = "";
        self.timezone_error_msg = "";
        self.role_error_msg = "";
        self.email_error_msg = "";
        self.work_phone_error_msg = "";
        self.mobile_phone_error_msg = "";
        self.home_phone_error_msg = "";
        self.other_phone_error_msg = "";
        self.leaving_date_error_msg = "";
        self.timeformat_error_msg = "";
        self.dateformat_error_msg = "";
        self.location_error_msg = "";
        self.shift_hours_error_msg = "";
        self.selectedDealerErrorMsg = "";
        self.dealerErrorMsg = "";
        self.billCusIdErrorMSg = "";

        self.username = self.username.trim();

        if(Date.parse(self.leaving_date) < Date.parse(self.joining_date)){
            self.leaving_date_error_msg = "Leave date should not be earlier than Start Date";
            error = true;
            error_step_1 = true;
        }
        if (!self.first_name || self.first_name == null || self.first_name == "") {
            self.first_name_error_msg = "First name can not be blank.";
            error = true;
            error_step_1 = true;
        }

        if (!self.username || self.username == null || self.username == "") {
            self.username_error_msg = "User name can not be blank.";
            error = true;
            error_step_1 = true;
        }

        if(!self.selectTimeFormat || self.selectTimeFormat == null || self.selectTimeFormat == "") {
            self.timeformat_error_msg = "Time format can not be blank.";
            error = true;
            error_step_1 = true;
        }
        if(!self.selectDateFormat || self.selectDateFormat == null || self.selectDateFormat == "") {
            self.dateformat_error_msg = "Date format can not be blank.";
            error = true;
            error_step_1 = true;
        }

        if(self.showDealers && self.selectedDealerArr.length == 0){
          self.dealerErrorMsg = "Dealer must be selected";
          error = true;
          error_step_1 = true;
        }

      if ((self.showDealers && self.loadAllDealers) && self.billCusId.length == 0) {
        self.billCusIdErrorMSg = "Bill Cus Id must be selected";
        error = true;
        error_step_1 = true;
      }

        // console.log("test ===",self.is_numeric(self.username));

        // if (self.username) {//&& !self.is_numeric(self.username) && !self.validEmail(self.username)
        //     self.username_error_msg = "Username must be in proper email format.";
        //     error = true;
        //     error_step_1 = true;
        // }

        if(segments[3]){
                self.password_error_msg = "";
                self.confirmpassword_error_msg = "";
        }else{

            if (!self.password || self.password == null || self.password == "") {
                self.password_error_msg = self.passNotMatchErr;
                error = true;
                error_step_1 = true;
            }

            if (self.password && self.password != null && self.password != "" && self.password.length < 8) {
                self.password_error_msg = self.passLengthErr;
                error = true;
                error_step_1 = true;
            }

            if (!self.confirmpassword || self.confirmpassword == null || self.confirmpassword == "") {
                self.confirmpassword_error_msg = self.confPassReqErr;
                error = true;
                error_step_1 = true;
            }

            if (self.password != self.confirmpassword && self.confirmpassword !="") {
                self.confirmpassword_error_msg = self.confPassMatchErr;
                error = true;
                error_step_1 = true;
            }
        }

        if (self.email && !self.validEmail(self.email)) {
            self.email_error_msg = "Enter valid email.";
            error = true;
            error_step_1 = true;
        }

        if (self.selectTimeZone == null || !self.selectTimeZone.value) {
            self.timezone_error_msg = "Time zone can not be blank.";
            error = true;
            error_step_1 = true;
        }

        if (self.selectRole == null || !self.selectRole[0]) {
            self.role_error_msg = "Role can not be blank.";
            error = true;
            error_step_1 = true;
        }

        if(self.zip){
          self.zip = self.zip.trim();
        }

        var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        // if(!self.work_phone || self.work_phone == null || self.work_phone == ""){
        //     self.work_phone_error_msg = "Work Phone Required.";
        //     error = true;
        //     error_step_1 = true;
        // }

        if(self.work_phone && self.work_phone != "___-___-____" && !self.work_phone.match(phoneRE) ){
            self.work_phone_error_msg = "Work phone number must be in proper format";
            error = true;
            error_step_1 = true;
        }

        if(!error_step_1) {

            if(self.home_phone && self.home_phone != "___-___-____" && !self.home_phone.match(phoneRE)){
                self.home_phone_error_msg = "Home phone number must be in proper format";
                error = true;
                error_step_2 = true;
            }

            if(self.mobile_phone && self.mobile_phone != "___-___-____" && !self.mobile_phone.match(phoneRE)){
                self.mobile_phone_error_msg = "Mobile phone number must be in proper format";
                error = true;
                error_step_2 = true;
            }

            if(self.other_phone && self.other_phone != "___-___-____" && !self.other_phone.match(phoneRE)){
                self.other_phone_error_msg = "Other phone number must be in proper format";
                error = true;
                error_step_2 = true;
            }
        }
        if (!error_step_2) {
            if( Date.parse(self.joining_date) > Date.parse(self.leaving_date) ){
                self.leaving_date_error_msg = "Leave Date should not be earlier than Start Date";
                error = true;
            }
            //role is technician

            if (self.selectRole != null && self.selectRole[0]) {
                // if (self.selectRole.text != null && self.selectRole.text != "") {
                for(var i = 0; i < self.selectRole.length; i++){
                    if (self.selectRole[i].name.toLowerCase() == "technician") {
                        if (self.shift_hours == "" || self.shift_hours == 0) {
                            self.shift_hours_error_msg = "Shift Hours Required.";
                            error = true;
                        }
                    }
                }
            }
        }

        if(!error){
            // checking bill cus id selected
            // but dealer not selected
            var checkedBillCusId = self.checkBillCusDealerSelect();

            checkedBillCusId.then((result) => {
                if (result) {
                    self.loading = true;

                    if (segments[3])
                    {
                        $("#createUserBtnStep1").text("Updating ...");
                        $("#createUserBtnStep1").prop("disabled", true);

                        $("#createUserBtnStep2").text("Updating ...");
                        $("#createUserBtnStep2").prop("disabled", true);

                        $("#createUserBtnStep3").text("Updating ...");
                        $("#createUserBtnStep3").prop("disabled", true);

                    } else {

                        if(flag == 'Save and Continue') {

                            $("#createAndContinueUserBtnStep1").text("Saving ...");
                            $("#createAndContinueUserBtnStep1").prop("disabled", true);
                            $("#createUserBtnStep1").prop("disabled", true);

                            $("#createAndContinueUserBtnStep2").text("Saving ...");
                            $("#createAndContinueUserBtnStep2").prop("disabled", true);
                            $("#createUserBtnStep2").prop("disabled", true);

                            $("#createAndContinueUserBtnStep3").text("Saving ...");
                            $("#createAndContinueUserBtnStep3").prop("disabled", true);
                            $("#createUserBtnStep3").prop("disabled", true);

                        }else{

                            $("#createUserBtnStep1").text("Saving ...");
                            $("#createUserBtnStep1").prop("disabled", true);
                            $("#createAndContinueUserBtnStep1").prop("disabled", true);

                            $("#createUserBtnStep2").text("Saving ...");
                            $("#createUserBtnStep2").prop("disabled", true);
                            $("#createAndContinueUserBtnStep1").prop("disabled", true);

                            $("#createUserBtnStep3").text("Saving ...");
                            $("#createUserBtnStep3").prop("disabled", true);
                            $("#createAndContinueUserBtnStep1").prop("disabled", true);

                        }

                    }
                    var fields = $("#userform").serializeArray();
                    fields.push({name: "timezone", value: self.selectTimeZone.value});
                    fields.push({name: "date_format", value: self.selectDateFormat.value});
                    fields.push({name: "time_format", value: self.selectTimeFormat.value});
                    fields.push({name: "role", value: JSON.stringify(self.selectRole)});
                    fields.push({name: "id", value: segments[3]});
                    fields.push({name: "username", value: self.username});
                    fields.push({name: "uploadedImage", value: self.uploadedImage});

                    if ( self.state == null ) {
                        fields.push({ name: "state_id", value: "" });
                    } else {
                        fields.push({ name: "state_id", value: self.state.value });
                    }
                    if ( self.city == null ) {
                        fields.push({ name: "city_id", value: "" });
                    } else {
                        fields.push({ name: "city_id", value: self.city.value });
                    }
                    if (self.home_phone != "___-___-____") {
                        fields.push({name: "home_phone", value: self.home_phone});
                    }else{
                        fields.push({name: "home_phone", value: ""});
                    }
                    if (self.mobile_phone != "___-___-____") {
                        fields.push({name: "mobile_phone", value: self.mobile_phone});
                    }else{
                        fields.push({name: "mobile_phone", value: ""});
                    }
                    if (self.other_phone != "___-___-____") {
                        fields.push({name: "other_phone", value: self.other_phone});
                    }else{
                        fields.push({name: "other_phone", value: ""});
                    }

                    fields.push({name: "selectedDealer", value: JSON.stringify(self.selectedDealerArr)});

                    //added permissions for security exeception
                    if (self.selectedPermissionsArr.length > 0) {
                        var userPermissions = [];
                        for(var i = 0;i<self.selectedPermissionsArr.length;i++) {
                            if (self.selectedPermissionsArr[i] != undefined && self.selectedPermissionsArr[i] != null) {
                                if (self.selectedPermissionsArr[i].permissions.length > 0) {
                                    for(var j = 0;j<self.selectedPermissionsArr[i].permissions.length;j++) {
                                        userPermissions.push(self.selectedPermissionsArr[i].permissions[j].id);
                                    }
                                }
                            }
                        }
                        fields.push({name: "added_permissions", value: userPermissions});
                    }else{
                        fields.push({name: "added_permissions", value: ""});
                    }
                    if (self.$route.params.id > 0) {
                        fields.push({name: "remove_permissions", value: self.removePermissionArr});
                    }


                    $.ajax({
                        url: process.env.ROOT_API + "/user/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if (segments[3])
                            {
                                $("#createUserBtnStep1").text("Update");
                                $("#createUserBtnStep1").prop("disabled", false);

                                $("#createUserBtnStep2").text("Update");
                                $("#createUserBtnStep2").prop("disabled", false);

                                $("#createUserBtnStep3").text("Update");
                                $("#createUserBtnStep3").prop("disabled", false);

                                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                                if(userObj != null){
                                    if(data.content.id == userObj.id){
                                        userObj.date_format = data.content.date_format;
                                        userObj.time_format = data.content.time_format;
                                        localStorage.setItem("user_obj",JSON.stringify(userObj));
                                    }
                                }

                            } else {

                                if(flag == 'Save and Continue') {

                                    $("#createAndContinueUserBtnStep1").text("Save and Continue");
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);
                                    $("#createUserBtnStep1").prop("disabled", false);

                                    $("#createAndContinueUserBtnStep2").text("Save and Continue");
                                    $("#createAndContinueUserBtnStep2").prop("disabled", false);
                                    $("#createUserBtnStep2").prop("disabled", false);

                                    $("#createAndContinueUserBtnStep3").text("Save and Continue");
                                    $("#createAndContinueUserBtnStep3").prop("disabled", false);
                                    $("#createUserBtnStep3").prop("disabled", false);

                                }else{

                                    $("#createUserBtnStep1").text("Save");
                                    $("#createUserBtnStep1").prop("disabled", false);
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);

                                    $("#createUserBtnStep2").text("Save");
                                    $("#createUserBtnStep2").prop("disabled", false);
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);

                                    $("#createUserBtnStep3").text("Save");
                                    $("#createUserBtnStep3").prop("disabled", false);
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);

                                }
                            }

                            //to handle when any error from SSO
                            if ( data.code == 201 && (data.status == 'success' || data.status == 'error' )) {

                                if (data.content.length > 0) {

                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }

                                    $(".errormsg").html(err);
                                    $(".alert-warning").toggleClass("show");

                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 15000);

                                }

                            }

                            if (data.status == "success" ) {

                                if(flag == 'Save and Continue') {

                                    $('div.setup-panel div a[href="#step-1"]').trigger('click');

                                    self.date_of_birth = "";
                                    self.joining_date = "";
                                    self.leaving_date = "";
                                    self.first_name = "";
                                    self.middle_name = "";
                                    self.last_name = "";
                                    self.email = "";
                                    self.username = "";
                                    self.password = "";
                                    self.confirmpassword = "";
                                    self.valueImage = false;
                                    self.imageURL = "";
                                    self.locationId = self.defaultLocationId;
                                    self.selectTimeZone = null;
                                    self.selectDateFormat = {value: "m/d/Y", text: '12/23/2019'};
                                    self.selectTimeFormat = {value: "h:i:s a", text: '09:58:00 am'};
                                    // self.timezoneArr = [];
                                    self.selectRole = null;
                                    //self.roleArr = [];
                                    self.rowsFiles = [];
                                    self.work_phone = "";
                                    self.mobile_phone = "";
                                    self.home_phone = "";
                                    self.other_phone = "";
                                    self.count = 0;
                                    self.address_1 = "";
                                    self.address_2 = "";
                                    self.city = null;
                                    self.state = null;
                                    self.zip = "";
                                    self.country = "";
                                    self.job_title = "";
                                    self.employee_no = "";
                                    self.license_no = "";
                                    self.license_class = "";
                                    self.license_state = "";
                                    self.hourly_labor_rate = "";
                                    self.removeAllFiles();
                                    self.moduleId = "";
                                    self.permissionArr = [];
                                    self.modulePermissionArr = [];
                                    self.selectedPermissionsArr = [];

                                } else {

                                if(data.code == 201) {
                                    self.$swal('',data.message,'success');
                                }

                                    //setTimeout(function () {
                                        self.$router.push("/user/list");
                                    //}, 3000);

                                }

                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#createUserBtnStep1").text("Update");
                                $("#createUserBtnStep1").prop("disabled", false);

                                $("#createUserBtnStep2").text("Update");
                                $("#createUserBtnStep2").prop("disabled", false);

                                $("#createUserBtnStep3").text("Update");
                                $("#createUserBtnStep3").prop("disabled", false);

                            } else {

                                if(flag == 'Save and Continue') {

                                    $('div.setup-panel div a[href="#step-1"]').trigger('click');


                                    $("#createAndContinueUserBtnStep1").text("Save and Continue");
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);
                                    $("#createUserBtnStep1").prop("disabled", false);

                                    $("#createAndContinueUserBtnStep2").text("Save and Continue");
                                    $("#createAndContinueUserBtnStep2").prop("disabled", false);
                                    $("#createUserBtnStep2").prop("disabled", false);

                                    $("#createAndContinueUserBtnStep3").text("Save and Continue");
                                    $("#createAndContinueUserBtnStep3").prop("disabled", false);
                                    $("#createUserBtnStep3").prop("disabled", false);

                                }else{

                                    $("#createUserBtnStep1").text("Save");
                                    $("#createUserBtnStep1").prop("disabled", false);
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);

                                    $("#createUserBtnStep2").text("Save");
                                    $("#createUserBtnStep2").prop("disabled", false);
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);

                                    $("#createUserBtnStep3").text("Save");
                                    $("#createUserBtnStep3").prop("disabled", false);
                                    $("#createAndContinueUserBtnStep1").prop("disabled", false);

                                }
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'store-user-data')
                        }
                    });
                }
            }).catch((error) => {
                console.log(error);
            });
        }else{
            if(error_step_1){
                $("#step1").click();
            }else{
                $("#step2").click();
            }
            self.errorValidationFocus();
        }

    },

    checkBillCusDealerSelect() {
        var self = this;

        return new Promise((resolve, reject) => {
            // Get the IDs from tempBillCussIdArr that do not exist in selectedDealerArr.parent_id
            const missingItems = self.tempBillCussIdArr.filter(item =>
                !self.selectedDealerArr.some(dealer => dealer.parent_id === item.value)
            );

            // Checking if all IDs exist in selectedDealerArr.parent_id
            const check = missingItems.length === 0;

            if (!check) {
                // Extract the text from the missing items
                const missingTexts = missingItems.map(item => item.text);

                self.$swal({
                    html: (!check ? '<span style="font-weight:bold;color:gray;font-size:20px;">Dealers from these Bill Cus Id\'s are not selected:</span><br>' + missingTexts.join(', ') + '<br><br>' : '') + '<span style="font-weight:bold;color:gray;font-size:20px;">Are you sure that you want to continue?</span>',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                }).catch(reject);
            } else {
                resolve(true);
            }
        });
    },

    loadUser() {

        this.isEdit = true;
        this.isUpdate = true;

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/user/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.username_disable = true;
                // $("#username").prop("disabled", true);
                $('div.setup-panel div a[href="#step-2"]').removeAttr('disabled');
                $('div.setup-panel div a[href="#step-3"]').removeAttr('disabled');
                $('div.setup-panel div a[href="#step-4"]').removeAttr('disabled');
                // console.log(data);
                if (data.status == "success") {
                   if ( data.content.timezone == null && !self.selectTimeZone.value ) {
                        self.selectTimeZone = null;
                    } else{
                        // self.selectTimeZone.value = data.content.timezone;
                        // self.selectTimeZone.text = data.content.timezone_name;
                        if (data.content.timezone && data.content.timezone != null){
                            self.selectTimeZone = {value: data.content.timezone, text: self.titleCase(data.content.timezone_name )};
                        }
                    }

                    self.selectDateFormat = {value: data.content.date_format, text: data.content.date};
                    self.selectTimeFormat = {value: data.content.time_format, text: data.content.time};

                    // console.log(data.content.roles[0].id);
                    self.first_name = data.content.first_name;
                    self.middle_name = data.content.middle_name;
                    self.last_name = data.content.last_name;
                    self.username = data.content.username;
                    self.email = data.content.email;
                    // self.selectTimeZone = {value: data.content.timezone, text: data.content.timezone_name};

                    self.work_phone = data.content.work_phone;
                    self.mobile_phone = data.content.mobile_phone;
                    if ( data.content.mobile_phone != 0 ) {
                        $("#div_mobile_phone").removeClass("hide");
                    } else{
                        self.mobile_phone = "";
                    }

                    self.home_phone = data.content.home_phone;
                    if ( data.content.home_phone != 0 ) {
                        $("#div_home_phone").removeClass("hide");
                    } else{
                        self.home_phone = "";
                    }

                    self.other_phone = data.content.other_phone;
                    if ( data.content.other_phone != 0 ) {
                        $("#div_other_phone").removeClass("hide");
                    } else{
                        self.other_phone = "";
                    }

                    self.address_1 = data.content.address_1;
                    self.address_2 = data.content.address_2;
                    if(data.content.city_id == 0 || data.content.city_id == null){
                        self.city = null;
                    } else{
                        self.city = {value: data.content.city_id, text: data.content.cityName};
                    }

                    if(data.content.state_id == 0 || data.content.state_id == null){
                        self.state = null;
                    } else{
                        self.state = {value: data.content.state_id, text: data.content.stateName};
                    }
                    if(data.content.zip == 0) {
                        self.zip = '';
                    } else {
                        self.zip = data.content.zip;
                    }
                    self.country = {value: data.content.country_id, text: data.content.countryName};
                    self.job_title = data.content.job_title;
                    self.joining_date = data.content.joining_date;
                    self.date_of_birth = data.content.date_of_birth;
                    self.leaving_date = data.content.leaving_date;
                    self.license_no = data.content.license_no;
                    self.license_class = data.content.license_class;
                    self.license_state = data.content.license_state;
                    self.hourly_labor_rate = data.content.hourly_labor_rate;
                    // self.employee_no = data.content.employee_no;
                    self.email = data.content.email;
                    // self.imageURL = {value: data.content.file_path, text: data.content.file_path};
                    self.imageURL = data.content.file_path;
                    self.selectRole = data.content.roles;//[{value: data.content.roles[0].id, text: data.content.roles[0].name}]
                    self.billCusId = data.content.billCusData;
                    self.populateDealers();

                    self.selectedDealerArr = data.content.userDealerData;
                    if(self.selectedDealerArr.length > 0){
                      self.selectedDealerErrorMsg = "";
                    }

                    var is_ins_agent = false;
                    if (self.selectRole.length > 0) {
                        for(var i = 0; i < self.selectRole.length; i++){
                            if (self.selectRole[i].name == 'Insurance Agent') {
                                is_ins_agent = true;
                            }
                        }
                    }

                    setTimeout(function () {
                        if(is_ins_agent) {
                            self.finalLocationArr = self.insLocationArr;
                        } else {
                            self.finalLocationArr = self.locationArr;
                        }
                        if ( data.content.location_id == null ) {
                            self.locationId = self.defaultLocationId;
                        } else{
                            self.locationId = {value: data.content.location_id, text: self.titleCase(data.content.locationName + " | " + data.content.locationCode )};
                        }
                    }, 1299);


                    if (data.content.added_permissions != undefined) {
                        self.selectedPermissionsArr = data.content.added_permissions;
                    }else{
                        self.selectedPermissionsArr = [];
                    }
                    self.shift_hours = data.content.shift_hours;

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'get-user-by-id')
            }
        });
    },
    validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    getModulePermissions() {
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/get-permissions",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.moduleArr = [];
                for(var i = 0;i< data.content.length;i++) {
                    var permissionArray = [];//module permission
                    for(var j = 0;j<data.content[i].module_permissions.length;j++) {
                        permissionArray.push({
                            module_id:data.content[i].module_permissions[j].module_id,
                            text:self.ucString(data.content[i].module_permissions[j].name),
                            name:data.content[i].module_permissions[j].permission_name,
                            value:data.content[i].module_permissions[j].id,
                            id:data.content[i].module_permissions[j].id
                        });
                    }
                    //module array
                    self.moduleArr.push({
                        text:self.ucString(data.content[i].module_name),
                        value:data.content[i].id,
                        module_permissions:permissionArray,
                    });
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'user-get-module-permission')
            }
        });
    },
    onModuleChange(evt) {
        var self = this;
        self.permissionArr = [];
        self.modulePermissionArr = [];
        self.module_error_msg = "";
        self.permission_error_msg = "";
        if (self.moduleId != null && self.moduleId != "") {
            self.modulePermissionArr = self.moduleId.module_permissions;//module-wise permission
        }
    },
    addPermissions() {
        var self = this;
        var error = false;
        self.module_error_msg = "";
        self.permission_error_msg = "";

        if (!self.moduleId || self.moduleId == null || self.moduleId == "") {
            self.module_error_msg = "Module Required.";
            error = true;
        }

        if (self.permissionArr.length < 1) {
            self.permission_error_msg = "Permission Required.";
            error = true;
        }

        if (!error) {

            if (self.selectedPermissionsArr.length < 1) {

                var addedPermissionsArray = [];

                for (var k = 0;k<self.permissionArr.length;k++) {
                    addedPermissionsArray.push({
                        module_id:self.moduleId.value,
                        text:self.ucString(self.permissionArr[k].text),
                        value:self.permissionArr[k].id,
                        id:self.permissionArr[k].id,
                        name:self.permissionArr[k].name,
                        added:0
                    });
                }
                self.selectedPermissionsArr.push({
                    added:0,
                    module_id:self.moduleId.value,
                    module_name:self.moduleId.text,
                    permissions:addedPermissionsArray
                });

            }else{

                var moduleFound = false;
                for (var i = 0;i < self.selectedPermissionsArr.length;i++) {
                    if (self.moduleId.value == self.selectedPermissionsArr[i].module_id) {
                        moduleFound = true;
                        for (var j = 0;j < self.permissionArr.length;j++) {
                            //check permission exists in selected permissions or not
                            var checkModulePermission = self.findElementIndex(self.selectedPermissionsArr[i].permissions,"id",self.permissionArr[j].id);
                            if (checkModulePermission == -1) {
                                self.selectedPermissionsArr[i].permissions.push({
                                    module_id:self.moduleId.value,
                                    text:self.ucString(self.permissionArr[j].text),
                                    value:self.permissionArr[j].id,
                                    id:self.permissionArr[j].id,
                                    name:self.permissionArr[j].name,
                                    added:0
                                });
                            }
                        }
                    }
                }

                if (!moduleFound) {
                    var addedPermissionsArray = [];

                    for (var k = 0;k<self.permissionArr.length;k++) {
                        addedPermissionsArray.push({
                            module_id:self.moduleId.value,
                            text:self.ucString(self.permissionArr[k].text),
                            value:self.permissionArr[k].id,
                            id:self.permissionArr[k].id,
                            name:self.permissionArr[k].name,
                            added:0
                        });
                    }

                    self.selectedPermissionsArr.push({
                        added:0,
                        module_id:self.moduleId.value,
                        module_name:self.moduleId.text,
                        permissions:addedPermissionsArray
                    });
                }
            }
            self.moduleId = "";
            self.permissionArr = [];
        }
    },
    removePermission(evt,index,permissionIndex,permissionId) {
        var self = this;

        if (self.selectedPermissionsArr[index] != undefined && self.selectedPermissionsArr[index] != null) {
            //while add permission
            if (self.selectedPermissionsArr[index].permissions[permissionIndex].added == 0) {
                self.selectedPermissionsArr[index].permissions.splice(permissionIndex,1);
            }else{
                self.removePermissionArr.push(permissionId);
                self.selectedPermissionsArr[index].permissions.splice(permissionIndex,1);
            }

            //if all permission of module removed then remove module from selected permissions
            if (self.selectedPermissionsArr[index].permissions.length < 1) {
                self.selectedPermissionsArr.splice(index,1);
            }
        }
    },
    findElementIndex(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    },
    resetFields() {
        var self = this;
        self.moduleId = "";
        self.permissionArr = "";
        self.module_error_msg = "";
        self.permission_error_msg = "";
    },
    populateDealers(){
      var self = this;
      if(self.loadAllDealers){
        self.loading = true;
        self.dealer = "";
        self.dealerArr = [];

        self.tempBillCussIdArr = [];
        for (let i = 0; i < self.billCusId.length; i++) {
          if (self.billCusId[i] && self.billCusId[i] !== 'undefined') {
            self.tempBillCussIdArr.push(self.billCusId[i]);
          }
        }
        $.ajax({
          url: process.env.ROOT_API + "/customer-from-parent-customer",
          type: "POST",
          data: {
            loadIds : self.billCusId,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            self.dealerArr = data.content;
            self.updateSelectedDealers();
          },
          error: function (jqXHR, exception) {

            self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'populate-dealer')
          }
        });
      }
    },
    updateSelectedDealers() {
      let updatedSelectedDealerArr = [];
      this.selectedDealerArr.forEach(selectedDealer => {
        if (this.dealerArr.some(dealer => dealer.value === selectedDealer.value)) {
          updatedSelectedDealerArr.push(selectedDealer);
        }
      });
      this.selectedDealerArr = updatedSelectedDealerArr;
    },
    selectDealer(){
      let addDealer = true;
      for (const element of this.selectedDealerArr) {
        if(element.value == this.dealer.value){
          this.selectedDealerErrorMsg = "Dealer has already been selected!";
          addDealer = false;
          break;
        }
      }
      if(addDealer){
        this.selectedDealerArr.push(this.dealer);
        this.selectedDealerErrorMsg = "";
      }
    },
    removeDealer(index) {
      let isSelectionMapped = this.dealerArr.findIndex(dealer =>
          dealer.value === this.selectedDealerArr[index].value
      );
      // can only delete the selected dealers if the selected dealer is in the dealerArr.
      if (isSelectionMapped !== -1) {
        if (this.selectedDealerArr.length > 1) {
          this.selectedDealerArr.splice(index, 1);
        } else {
          this.selectedDealerArr = [];
        }
        this.selectedDealerErrorMsg = "";
      }else{
        this.selectedDealerErrorMsg = "Cannot Remove this Dealer!"
      }
    },
    getUserDefaultLocation() {
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/default-user-location",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.defaultLocationId = data.content;
                self.locationId = self.defaultLocationId;
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'user-get-module-permission')
            }
        });
    },
  }
};
</script>




// WEBPACK FOOTER //
// src/components/UserCreate.vue